import Routes from './routes/';
import './App.css';
import './i18n';

function App() {
    return (
        <div className="App">
            <Routes />
        </div>
    );
}

export default App;
